import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import {
  actionStatusClassName,
  actionStatusDescription,
  actionStatusLabel,
} from '../../../../core/constants/action-status.constant';
import { ActionClientStatus } from '../../../../core/interfaces';

@Component({
  selector: 'x-status-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './x-status-badge.component.html',
  styleUrl: './x-status-badge.component.scss',
})
export class XStatusBadgeComponent {
  status = input.required<ActionClientStatus | string>();

  readonly label = computed(() => actionStatusLabel(this.status()));
  readonly description = computed(() => actionStatusDescription(this.status()));
  readonly cssClass = computed(
    () => `status-badge status-badge--${actionStatusClassName(this.status())}`
  );
  readonly tooltip = computed(() => {
    const description = this.description();
    return description ? `${this.label()}: ${description}` : this.label();
  });
}
